import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import Reveal from './Reveal';

const funnel = [
  { label: 'Applied', value: 100, tone: 'bg-brand-500/25' },
  { label: 'Passed subject test', value: 46, tone: 'bg-brand-500/45' },
  { label: 'Passed mock lesson', value: 21, tone: 'bg-brand-500/70' },
  { label: 'Tutoring today', value: 12, tone: 'bg-brand-600' },
];

const checks = [
  'Studying at, or recently graduated from, a UK university',
  'Sat the same specification within the last few years',
  'Enhanced DBS check completed before their first lesson',
  'Rated after every session — below 4.5 and we step in',
];

const TutorQuality: React.FC = () => (
  <section className="section-shell py-20 sm:py-28">
    <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <p className="eyebrow">Our tutors</p>
        <h2 className="display mt-3 text-4xl text-balance sm:text-5xl">
          We turn away
          {' '}
          <span className="italic text-brand-600 dark:text-brand-400">seven in eight</span>
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-base-content/60">
          Being clever isn&apos;t the bar — being able to explain it is. Our tutors sat the same
          papers your teen is sitting, recently enough to remember exactly where it gets hard.
          They double as the cool older role model, which is half the battle.
        </p>

        <ul className="mt-8 space-y-3.5">
          {checks.map((check) => (
            <li key={check} className="flex items-start gap-3">
              <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400">
                <Check className="h-3 w-3" strokeWidth={3} />
              </span>
              <span className="text-[15px] text-base-content/70">{check}</span>
            </li>
          ))}
        </ul>

        <Link
          to="/team"
          className="group mt-9 inline-flex items-center gap-2 text-[15px] font-semibold text-brand-600 dark:text-brand-400"
        >
          Meet the team behind Tütr
          <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
        </Link>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="surface p-8 shadow-soft sm:p-10">
          <p className="text-sm font-semibold">Tutor application funnel</p>
          <p className="mt-1 text-xs text-base-content/50">Per 100 applicants, last 12 months</p>

          <div className="mt-8 space-y-5">
            {funnel.map((step) => (
              <div key={step.label}>
                <div className="mb-2 flex items-baseline justify-between">
                  <span className="text-[13px] font-medium text-base-content/70">{step.label}</span>
                  <span className="text-sm font-semibold tabular-nums text-base-content/45">
                    {step.value}
                  </span>
                </div>
                <div className="h-3 overflow-hidden rounded-full bg-base-200 ring-1 ring-inset ring-ink-900/[0.04] dark:ring-white/5">
                  <div
                    className={`h-full rounded-full ${step.tone}`}
                    style={{ width: `${step.value}%` }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-xl border border-brand-500/20 bg-brand-500/[0.07] px-4 py-3.5">
            <p className="text-[13px] leading-snug text-base-content/70">
              <span className="font-semibold">The last step is the hard one.</span>
              {' '}
              Half of everyone who passes our subject test still can&apos;t teach it.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default TutorQuality;
